// components/chat-surface/chat-slash-picker.js
// ═══════════════════════════════════════════════════════════
// Slash command picker. Appears above the input bar when user types /
// Pass custom commands per feature via the `commands` prop.
// ═══════════════════════════════════════════════════════════

// ── Default commands (features can override or extend) ──
export const DEFAULT_COMMANDS = [
  { id: 'canvas', label: '/canvas', desc: 'Build something on the canvas', icon: '◎', color: '#c8a96e' },
  { id: 'deep', label: '/deep', desc: 'Deep analysis mode — thorough and verified', icon: '◈', color: '#9b8fc4' },
  { id: 'compare', label: '/compare', desc: 'Compare two options side by side', icon: '⇆', color: '#7a9e82' },
  { id: 'summarize', label: '/summarize', desc: 'Summarize our conversation so far', icon: '≡', color: '#888' },
  { id: 'plan', label: '/plan', desc: 'Create an action plan from what we discussed', icon: '▣', color: '#c8a96e' },
  { id: 'table', label: '/table', desc: 'Organize data into a table on canvas', icon: '⊞', color: '#7a9e82' },
  { id: 'export', label: '/export', desc: 'Export this as a document', icon: '↗', color: '#888' },
  { id: 'reset', label: '/reset', desc: 'Clear context and start fresh', icon: '↺', color: '#c46050' },
];

export default function ChatSlashPicker({ query, commands, onSelect, visible }) {
  if (!visible) return null;
  const cmds = commands || DEFAULT_COMMANDS;
  const filtered = cmds.filter(c =>
    c.id.includes(query) || c.desc.toLowerCase().includes(query)
  );
  if (filtered.length === 0) return null;

  return (
    <div style={{
      position: 'absolute', bottom: '100%', left: 0, right: 0,
      background: '#07070a', border: '1px solid #1e1e2a',
      borderRadius: 8, padding: '6px 0', marginBottom: 4,
      boxShadow: '0 -4px 16px rgba(0,0,0,0.5)', zIndex: 30,
      maxHeight: 260, overflowY: 'auto',
    }}>
      <div style={{
        padding: '4px 12px 6px', fontSize: 9, color: '#333',
        fontFamily: 'Georgia, serif', letterSpacing: '0.1em',
        textTransform: 'uppercase',
      }}>
        Commands
      </div>
      {filtered.map(cmd => (
        <button
          key={cmd.id}
          onClick={() => onSelect(cmd)}
          style={{
            display: 'flex', alignItems: 'center', gap: 8,
            width: '100%', padding: '7px 12px', background: 'none',
            border: 'none', cursor: 'pointer', textAlign: 'left',
            transition: 'background 0.1s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#141414'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
        >
          <span style={{ fontSize: 12, color: cmd.color, width: 18, textAlign: 'center' }}>{cmd.icon}</span>
          <div>
            <div style={{ fontSize: 11, color: '#d4d4d4', fontFamily: 'Georgia, serif' }}>{cmd.label}</div>
            <div style={{ fontSize: 9, color: '#555', fontFamily: 'Georgia, serif' }}>{cmd.desc}</div>
          </div>
        </button>
      ))}
    </div>
  );
}
